var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOutageWarning)?_c('div',{staticClass:"outage-warning"},[_vm._v("\r\n      Please save your work as the system will be shutting down for maintenance in\r\n      ~"+_vm._s(_vm.countDownValue)+" minutes\r\n    ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }